<div class="row nav-bg no-gutters">
  <div class="col-auto">
    <img class="brand-logo" src="assets/images/logo/nissan-next-logo-white.png" alt="Nissan" />
  </div>
  <div *ngIf="isLoggedIn" class="col my-auto">
    <div *ngIf="!issmSearchClicked" class="row no-gutters">
      <div class="col-auto">
        <div class="dropdown" *ngIf="showNavigationOptions">
          <img class="img-fluid cursor-pointer dropdown-toggle" src="assets/images/NavMenu.png" alt="support"
            id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
          <div class="dropdown-menu menu-dropdown" aria-labelledby="dropdownMenuButton">
            <ng-container *ngIf="(isAdmin && (isServiceProviderAccount() || isRentalFleetAccount() || isFleetManagementCompany() || isDealerAccount() || isCorporateAccount())) 
              || authService.isDongleProvider()">
              <a *ngFor="let option of authService.navigationOptions"
                class="dropdown-item cursor-pointer border-bottom p-1 p-md-2 font16-400" routerLink="{{option.route}}">
                <img class="img-fluid width-em-2" src="{{option.imageSource}}" alt="{{option.alt}}" />
                <span class="ml-2">{{option.label}}</span><br>
              </a>
            </ng-container>
            <ng-container *ngIf="isDeveloper">
              <a class="dropdown-item cursor-pointer border-bottom p-1 p-md-2 font16-400"
                (click)="apiAccess.openDeveloperAccess()">
                <img class="img-fluid width-em-2" src="assets/images/developer-access.png" alt="developer access" />
                <span class="ml-2">Developer Access</span>
              </a>
              <a class="dropdown-item cursor-pointer border-bottom p-1 p-md-2 font16-400" routerLink="/swagger-ui">
                <img class="img-fluid width-em-2" src="assets/images/developer-access.png" alt="Swagger" />
                <span class="ml-2">Developer APIs</span><br>
              </a>
              <a class="dropdown-item cursor-pointer border-bottom p-1 p-md-2 font16-400" routerLink="/support">
                <img class="img-fluid width-em-2" src="assets/images/question.png" alt="support" />
                <span class="ml-2">Support</span><br>
              </a>
            </ng-container>
            <ng-container *ngIf="isFinanceAdmin">
              <a class="dropdown-item cursor-pointer border-bottom p-1 p-md-2 font16-400" routerLink="/invoices">
                <img class="img-fluid width-em-2" src="assets/images/usage.png" alt="invoices" />
                <span class="ml-2">Invoices</span><br>
              </a>
              <a class="dropdown-item cursor-pointer border-bottom p-1 p-md-2 font16-400" routerLink="/support">
                <img class="img-fluid width-em-2" src="assets/images/question.png" alt="support" />
                <span class="ml-2">Support</span><br>
              </a>
            </ng-container>
            <a class="d-block d-sm-none dropdown-item cursor-pointer border-bottom p-1 p-md-2 font16-400"
              data-toggle="modal" data-target="#userProfile" data-backdrop="static" data-keyboard="false">
              <img class="img-fluid width-em-2" src="assets/images/user.png" alt="profile" />
              <span class="ml-2 align-middle">Profile</span>
            </a>
            <a class="d-block d-sm-none dropdown-item cursor-pointer p-1 p-md-2 font16-400" (click)="onLogOut()"
              routerLink="/">
              <i class="fa fa-sign-out" style="font-size: 25px" aria-hidden="true"></i>
              <span class="ml-2" style="vertical-align: super;">Logout</span>
            </a>
          </div>&nbsp;
          <span class="cursor-pointer text-white font16-400" [routerLink]="homePageRoute">{{loggedInUser}}</span>
        </div>
      </div>
      <div class="col my-auto d-none d-sm-block">
        <div class="row no-gutters">
          <div class="col">
            <form *ngIf="showSearchBox">
              <app-search></app-search>
            </form>
          </div>
          <div class="col-auto my-auto ml-3 text-right">
            <ng-container *ngIf="showNotification">
              <i class="fa fa-bell-o notification-icon pointer" routerLink="/notifications"></i>
              <span *ngIf="notifications.length" class="notification-badge font-12">{{notifications.length}}</span>
            </ng-container>
          </div>
          <div class="col-auto mx-3 my-auto">
            <div class="dropdown">
              <img class="img-fluid dropdown-toggle pointer" style="height:38px; width:38px"
                src="assets/images/NavAccount.png" alt="support" id="dropdownMenuButton11" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false" />
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton11">
                <a class="dropdown-item">
                  <i class="fas fa-user maroon"></i>
                  <span class="ml-2 pointer" data-toggle="modal" data-target="#userProfile" data-backdrop="static"
                    data-keyboard="false">
                    {{authService.loggedInUser.name}}</span>
                </a>
                <a class="dropdown-item">
                  <i class="fa fa-sign-out maroon" aria-hidden="true"></i>
                  <span class="ml-2 pointer" (click)="onLogOut()" routerLink="/">Logout</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col d-block d-sm-none my-auto text-right">
        <div class="row p-0 m-0">
          <div class="col p-0 mr-2 my-auto text-right">
            <ng-container *ngIf="showNotification">
              <i class="fa fa-bell-o notification-icon pointer" routerLink="/notifications"></i>
              <span *ngIf="notifications.length" class="notification-badge font-12">{{notifications.length}}</span>
            </ng-container>
          </div>
          <div class="col-auto p-0">
            <button *ngIf="showSearchBox" class="btn btn-sm-search mx-2" (click)="smSearchClicked()"><i
                class="fa fa-search"></i></button>
          </div>
        </div>
      </div>
    </div>

    <div class="row d-block d-sm-none no-gutters mr-2" *ngIf="issmSearchClicked">
      <div class="col pr-0">
        <form class="my-1">
          <div class="input-group">
            <input type="text" class="form-control font-1rem height-auto" [(ngModel)]="searchKey" name="searchInput"
              #searchInput="ngModel" [placeholder]="searchPlaceholder">
            <div class="input-group-append">
              <button class="btn btn-sm-search" (click)="search()"><i class="fa fa-search"></i></button>
              <button class="btn btn-outline-danger" (click)="smSearchClicked()"><i class="fa fa-close"></i></button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Modal Account Profile -->
<div class="modal fade" id="userProfile" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content" *ngIf="loggedInUser">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="userProfileTitle">Account Profile</h5>
        <button type="button" class="close" (click)="userProfileView.resetModels()" data-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-account-profile #userProfileView [isPhoneNumberVerified]="isPhoneNumberVerified"
          (profileUpdatedEmitter)="onProfileUpdate()"></app-account-profile>
      </div>
    </div>
  </div>
</div>

<!-- Modal API Access -->
<developer-access modalId="headerDeveloperAccess" modalOpenButtonId="openHeaderDeveloperAccess"
  modalCloseButtonId="closeHeaderDeveloperAccess" #apiAccess></developer-access>

<!-- <user-tnc #userTnc (routeToHomeEmitter)="onRouteToHome()"></user-tnc> -->
<user-tnc #userTnc (userTnCAccepted)="showUserPreferenceModal()"></user-tnc>

<!-- Language Preference Model -->
<app-language-preference #userLanguagePreference (routeToHomeEmitter)="onRouteToHome()"></app-language-preference>

<!-- Verify mfa otp  id : resendMFACode-->
<button type="button" class="btn btn-primary" id="openResendCodeModal" [hidden]="true" data-toggle="modal"
  data-target="#resendMFACode" data-backdrop="static" data-keyboard="false">Hidden
  Btn</button>
<div class="modal fade" id="resendMFACode" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="verifyCodeTitle">Verify Verification Code</h5>
        <button id="closeVerifyCode" type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="resetSmsMfaVerificationForm();">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form #smsMfaVerificationForm="ngForm" novalidate (ngSubmit)="mfaFormSubmit(smsMfaVerificationForm)">
        <div class="modal-body fix-height-40">
          <div class="form-group">
            <!-- <label>{{mfaFormLabel}}</label><br> -->
            <small class="text-muted">
              {{mfaFormMessagePreMobileNumber}} <span *ngIf="smsMfaData"> {{smsMfaData.destination}}</span>
              {{mfaFormMessagePostMobileNumber}}
            </small>
            <input type="text" class="form-control mt-4" pattern="[0-9]{6}"
              oninput="this.value = this.value.replace(/[^0-9]/g, '');" maxlength="6"
              [(ngModel)]="smsMfaVerificationModel.code" name="code" #code="ngModel" required>
            <small class="text-danger text-center" *ngIf="code.errors && smsMfaVerificationForm.submitted">
              <p class="mb-0" *ngIf="code.errors.required">Code is required</p>
              <p class="mb-0" *ngIf="!code.errors.required">Invalid verification code</p>
            </small>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light btn-80" (click)="resetSmsMfaVerificationForm()"
            data-dismiss="modal">CANCEL</button>
          <button type="submit" class="btn btn-primary btn-80">Submit</button>
        </div>
      </form>
    </div>
  </div>
</div>